<template>
	<article class="applying-email-change content content-400">
			<spinner :text="'Updating Email Address'" v-if="processing"></spinner>
			<div v-else-if="confirmEmailError">
				<div class="column separated-extra notice info" v-if="confirmEmailError.type === 'TOKEN_USED'">
					<div class="row rigid">
						Your email address has already been updated.
					</div>
					<div class="row right rigid">
						<a href="#/" class="button">OK</a>
					</div>
				</div>

				<div class="notice error" v-else-if="confirmEmailError.type === 'INVALID_TOKEN'">
					I'm not sure what you're attempting to do, but it's not working.
				</div>

				<div class="notice error" v-else-if="confirmEmailError.type === 'TOKEN_EXPIRED'">
					You don't seem to be whom I was expecting. <br>
					<a v-bind:href="loginAddress">Sign in</a> with your old email address and try again.
				</div>

				<div class="notice error" v-else-if="confirmEmailError.type === 'INVALID_USER'">
					You don't seem to be whom I was expecting. <br>
					<a v-bind:href="loginAddress">Sign in</a> with your old email address and try again.
				</div>

				<div class="notice error" v-else>
					This is an ambiguous error message because something unexpected happened.
				</div>
			</div>
			<div class="column separated notice success" v-else-if="!confirmEmailError">
				<div class="row rigid">Your email address has been updated.</div>
				<div class="row right rigid">
					<a href="#/" class="button">OK</a>
				</div>
			</div>
			
	</article>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Spinner from '../components/SpinnerNew.vue';

export default {
	name: 'ConfirmEmailChange',
	computed: {
		...mapGetters([
			'user',
			'userStatus',
			'AUTH_API'
		]),
		...mapGetters('auth', [
			'authRedirectUrl',
			'refreshTokenJTI'
		]),
		...mapState('auth', [
			'refreshToken'
		]),
		emailToken() {
			return this.$route.params.emailToken;
		},
		authUrl() {
			const returnClient = 'client=' + encodeURIComponent((window.location.origin || '') + '#/signin');
			return this.authRedirectUrl + '?' + returnClient;
		},
		loginAddress(){
			return this.authUrl + '&emailToken=' + this.emailToken;
		}
	},
	data() {
		return {
			password: '',
			processing: true,
			confirmEmailError: null
		};
	},
	components: {
		Spinner: Spinner
	},
	created(){
		const vm = this;
		this.$store.dispatch('CONFIRM_EMAIL_REQUEST', this.emailToken)
			.then(() => {
				// logout and send to auth signin to get a new refresh token
				vm.$store.dispatch('auth/LOGOUT', vm.refreshTokenJTI)
					.then(() => {
						vm.processing = false;
						window.location.href = vm.authUrl + '&reason=email';
					});
			})
			.catch((reason) => {
				vm.processing = false;
				vm.confirmEmailError = reason;
			});
	}

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.applying-email-change {
		padding: 0 1em;
	}

	.right {
		margin-left: auto;
		margin-right: 0;
	}
</style>



// WEBPACK FOOTER //
// ./src/views/ConfirmEmailChange.vue